/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
	<div class="result-object">
		<Notification ref="notif" :closed="true" corner="bottom-right" />
		<h2 class="page-title"><em>Objetos</em></h2>

		<div class="search-infos">
			<p><strong>VOCÊ PESQUISOU:</strong> {{ this.$route.query.texto || '' }}</p>
			<p>Aproximadamente {{ totalDeObjetos }} resultados</p>
		</div>

		<div class="search-result">
			<div class="filters">
				<router-link :to="{ name: 'resultadoObjeto', query: {buscarPor: 'objeto'} }"><i class="fas fa-cubes" /> OBJETOS</router-link>
				<router-link :to="{ name: 'resultadoColecao', query: {buscarPor: 'colecao'}  }"><i class="fas fa-folder" /> COLEÇÕES</router-link>

				<div class="clean-filters">
					<div>
						<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
						<button type="button" v-if="filtros.texto" @click="resetFilter('texto')">{{filtros.texto}}<i class="far fa-times-circle" /></button>
						<button type="button" v-if="filtros.data" @click="resetFilter('data')">{{filtros.data}}<i class="far fa-times-circle" /></button>
						<button type="button" v-for="tipo in tipos" v-if="tipos.length > 0 && filtros.tipos.includes(tipo.id)" :key="tipo.id" @click="resetFilter('tipos', tipo.id)">{{tipo.nome}}<i class="far fa-times-circle" /></button>
						<button type="button" v-for="curadoria in curadorias" v-if="curadorias.length > 0 && filtros.curadorias.includes(curadoria.id)" :key="curadoria.id" @click="resetFilter('curadorias', curadoria.id)">{{curadoria.nome}}<i class="far fa-times-circle" /></button>
						<button type="button" v-for="subcuradoria in subcuradorias" v-if="subcuradorias.length > 0 && filtros.subcuradorias.includes(subcuradoria.id)" :key="subcuradoria.id" @click="resetFilter('subcuradorias', subcuradoria.id)">{{subcuradoria.nome}}<i class="far fa-times-circle" /></button>
						<button type="button" v-for="eixo in eixos" v-if="eixos.length > 0 && filtros.eixos.includes(eixo.id)" :key="eixo.id" @click="resetFilter('eixos', eixo.id)">{{eixo.nome}}<i class="far fa-times-circle" /></button>					</div>
					<div>
						<button type="button" @click="resetFilters">Limpar todos os filtros <i class="far fa-times-circle" /></button>
					</div>
				</div>

				<div class="filters">
					<div class="box-data">
						<div class="icon-date" @click="open">
							<i class="material-icons">today</i>
							<span v-if="filtros.data">MODIFICAR</span>
							<span v-else>ESCOLHER DATA</span>
						</div>
						<div class="data">
								<datepicker ref="dp1" v-model="data" @input="searchDate" :language="lang" input-class="input-format" :format="DatePickerFormat"></datepicker>
						</div>
					</div>
					<filter-container title="Cursos Recorrentes">
						<div class="search">
							<input class="input-cursos-recorrentes" type="text" placeholder="Filtrar" maxlength="200"
							@keyup="(e) => changeCursosRecorrente(e)" />
							<i class="fas fa-search"></i>
						</div>
						<checkbox v-for="cursoRecorrente in cursosRecorrentes" :key="cursoRecorrente.id"
						:value="cursoRecorrente" :name="cursoRecorrente.id" @change="() => changeCheckeCursoRecorrente(cursoRecorrente)" :checked="fillCursosRecorrentes(cursoRecorrente)" />
					</filter-container>

					<filter-container title="Disciplinas Recorrentes">
						<div class="search">
							<input class="input-disciplinas-recorrentes" type="text" placeholder="Filtrar" maxlength="200" @keyup="(e) => changeDisciplinaRecorrente(e)" />
							<i class="fas fa-search"></i>
						</div>
						<checkbox v-for="disciplinaRecorrente in disciplinasRecorrentes" :key="disciplinaRecorrente.id"
						:value="disciplinaRecorrente" :name="disciplinaRecorrente.id" @change="() => changeCheckeDiscRecorrente(disciplinaRecorrente)" :checked="fillDisciplinasRecorrentes(disciplinaRecorrente)" />
					</filter-container>

					<filter-container title="Tipo de Objeto">
						<checkbox v-for="tipo in tipos" :key="tipo.id" :value="tipo" :name="tipo.id" @change="() => changeTipoDeObjeto(tipo)" :checked="fillTipoDeObjeto(tipo)" />
					</filter-container>

					<filter-container title="Curadoria">
						<div class="search">
							<input class="input-curadorias" type="text" placeholder="Filtrar" maxlength="200"
							@keyup="(e) => changeFiltrarCuradoria(e)" />
							<i class="fas fa-search"></i>
						</div>
						<checkbox v-for="curadoria in curadorias" :key="curadoria.id" :value="curadoria" :name="curadoria.id"
						@change="() => changeCuradoriaDeObjeto(curadoria)" :checked="fillCuradoriaDeObjeto(curadoria)" />
					</filter-container>

					<filter-container title="Sub-curadoria" v-if="subcuradorias.length">
						<div class="search">
							<input class="input-subCuradorias" type="text" placeholder="Filtrar" maxlength="200"
							@keyup="(e) => changeFiltrarSubCuradoria(e)" />
							<i class="fas fa-search"></i>
						</div>
						<checkbox v-for="subcuradoria in subcuradorias" :key="subcuradoria.id" :value="subcuradoria"
						:name="subcuradoria.id" @change="() => changeSubCuradoriaDeObjeto(subcuradoria)" :checked="fillSubAreaDeObjeto(subcuradoria)" />
					</filter-container>

					<filter-container title="Eixo" v-if="eixos.length">
						<div class="search">
							<input class="input-eixos" type="text" placeholder="Filtrar" maxlength="200"
							@keyup="(e) => changeFiltrarEixo(e)"  />
							<i class="fas fa-search"></i>
						</div>
						<checkbox v-for="eixo in eixos" :key="eixo.id" :value="eixo" :name="eixo.id"
						@change="() => changeEixoDeObjeto(eixo)" :checked="fillEixoDeObjeto(eixo)" />
					</filter-container>
				</div>

			</div>

			<div class="objects" v-if="totalDeObjetos > 0" >
				<objeto v-for="objeto in objetos" :key="objeto.id" :objeto="objeto" />
			</div>
			<div v-else-if="loadContent === false" class="result">
				<p>0 objetos encontrados!</p>
			</div>
		</div>

		<div class="paginacao" v-if="totalDeObjetos > 20">
			<Pagination :totalItens="totalDeObjetos" :currentPage="currentPage" @pagina="buscarObjetos" />
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import { tipos } from '@/services/tipos'
import { curadorias } from '@/services/curadorias'
import { objetos } from '@/services/objetos'
import { tags } from '@/services/tags'
import FilterContainer from '../shared/FilterContainer'
import EventBus from './../../../event-bus'
import Objeto from './BoxObjeto'
import Checkbox from '../shared/Checkbox'
import Pagination from '@/components/shared/Pagination'

export default {
	name: 'ObjectResult',
	components: { FilterContainer, Checkbox, Objeto, Pagination, Datepicker },
	data () {
		return {
			tipos: [],
			curadorias: [],
			subcuradoriasList: [],
			curadoriasBackup: [],
			subcuradoriasBackup: [],
			eixosBackup: [],
			eixosList: [],
			cursosRecorrentes: [],
			cursosRecorrentesBackup: [],
			disciplinasRecorrentes: [],
			disciplinasRecorrentesBackup: [],
			objetos: [],
			filtros: {
				texto: '',
				data: '',
				tipos: [],
				curadorias: [],
				subcuradorias: [],
				eixos: [],
				disciplinaId: [],
				cursoId: [],
				buscarPor: 'object'
			},
			data: '',
			loadContent: true,
			DatePickerFormat: 'dd/MM/yyyy',
			totalDeObjetos: 0,
			currentPage: 1,
			lang: ptBR,
			parametros: {}
		}
	},
	computed: {
		subcuradorias: {
			get: function () {
				const subcuradoriasListAux = this.subcuradoriasList
				let curadorias = this.filtros.curadorias
				curadorias = curadorias.map(el => {
					const curadoria = this.curadorias.find(el2 => el === el2.id)
					return curadoria ? curadoria.subCuradorias : []
				})
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.subcuradoriasBackup = [].concat(...curadorias.filter(el => el.length > 0)).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
				return subcuradoriasListAux.length > 0 ? subcuradoriasListAux : [].concat(...curadorias.filter(el => el.length > 0)).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
			},
			set: function (curadorias) {
				this.subcuradoriasList = curadorias
			}
		},
		// subcuradorias (teste) {
		// 	let curadorias = this.filtros.curadorias || []
		// 	curadorias = curadorias.map(el => {
		// 		const curadoria = this.curadorias.find(el2 => el === el2.id)
		// 		return curadoria ? curadoria.subCuradorias : []
		// 	})
		// 	// eslint-disable-next-line vue/no-side-effects-in-computed-properties
		// 	return [].concat(...curadorias.filter(el => el.length > 0)).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
		// },

		// eixos () {
		// 	let subcuradorias = this.filtros.subcuradorias || []
		// 	subcuradorias = subcuradorias.map(el => {
		// 		const subcuradoriaFilter = this.subcuradorias.find(el2 => el === el2.id)
		// 		return subcuradoriaFilter ? subcuradoriaFilter.subCuradorias : []
		// 	})
		// 	return [].concat(...subcuradorias.filter(el => el.length > 0)).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
		// }
		eixos: {
			get: function () {
				const eixosListAux = this.eixosList
				let subcuradorias = this.filtros.subcuradorias
				subcuradorias = subcuradorias.map(el => {
					const subcuradoriaFilter = this.subcuradorias.find(el2 => el === el2.id)
					return subcuradoriaFilter ? subcuradoriaFilter.subCuradorias : []
				})
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.eixosBackup = [].concat(...subcuradorias.filter(el => el.length > 0)).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
				return eixosListAux.length > 0 ? eixosListAux : [].concat(...subcuradorias.filter(el => el.length > 0)).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
			},
			set: function (eixos) {
				this.eixosList = eixos
			}
		}
	},
	watch: {
		'$route.query': function () {
			this.obterFiltros()
			this.buscarObjetos()
		}
	},
	methods: {
		changeTipoDeObjeto (tipo) {
			const exists = this.filtros.tipos.some(value => value === tipo.id)
			if (exists) this.filtros.tipos = this.filtros.tipos.filter(value => value !== tipo.id)
			else this.filtros.tipos.push(tipo.id)

			return this.updateRoute()
		},
		changeCuradoriaDeObjeto (curadoria) {
			const exists = this.filtros.curadorias.some(value => value === curadoria.id)
			if (exists) {
				this.updateFilters(curadoria, 'curadorias')
				this.filtros.curadorias = this.filtros.curadorias.filter(value => value !== curadoria.id)
			} else {
				this.filtros.curadorias.push(curadoria.id)
			}
			this.subcuradoriasList = []

			return this.updateRoute()
		},
		changeSubCuradoriaDeObjeto (subcuradoria) {
			const exists = this.filtros.subcuradorias.some(value => value === subcuradoria.id)

			if (exists) {
				this.updateFilters(subcuradoria, 'subcuradorias')
				this.filtros.subcuradorias = this.filtros.subcuradorias.filter(value => value !== subcuradoria.id)
			} else {
				this.filtros.subcuradorias.push(subcuradoria.id)
			}
			this.eixosList = []
			return this.updateRoute()
		},
		changeEixoDeObjeto (eixo) {
			const exists = this.filtros.eixos.some(value => value === eixo.id)

			if (exists) this.filtros.eixos = this.filtros.eixos.filter(value => value !== eixo.id)
			else this.filtros.eixos.push(eixo.id)

			return this.updateRoute()
		},
		changeCheckeDiscRecorrente (disciplinaRecorrente) {
			const exists = this.filtros.disciplinaId.some(value => value === disciplinaRecorrente.id)
			if (exists) this.filtros.disciplinaId = this.filtros.disciplinaId.filter(value => value !== disciplinaRecorrente.id)
			else this.filtros.disciplinaId.push(disciplinaRecorrente.id)

			return this.updateRoute()
		},
		changeCheckeCursoRecorrente (cursoRecorrente) {
			const exists = this.filtros.cursoId.some(value => value === cursoRecorrente.id)
			if (exists) this.filtros.cursoId = this.filtros.cursoId.filter(value => value !== cursoRecorrente.id)
			else this.filtros.cursoId.push(cursoRecorrente.id)

			return this.updateRoute()
		},
		customFormatter (date) {
			this.data = date
			this.filtros.data = moment(date).format('DD/MM/YYYY')
			// return this.updateRoute()
		},
		searchDate () {
			this.filtros.data = moment(this.data).format('DD/MM/YYYY')
			this.updateRoute()
		},
		fillTipoDeObjeto (tipo) {
			const isChecked = this.filtros.tipos.some(value => value === tipo.id)
			if (isChecked) return true

			return false
		},
		fillCuradoriaDeObjeto (curadoria) {
			const isChecked = this.filtros.curadorias.some(value => value === curadoria.id)
			if (isChecked) return true

			return false
		},
		fillSubAreaDeObjeto (subarea) {
			const isChecked = this.filtros.subcuradorias.some(value => value === subarea.id)
			if (isChecked) return true

			return false
		},
		fillEixoDeObjeto (Eixo) {
			const isChecked = this.filtros.eixos.some(value => value === Eixo.id)
			if (isChecked) return true

			return false
		},
		fillCursosRecorrentes (cursoRecorrente) {
			const isChecked = this.filtros.cursoId.some(value => value === cursoRecorrente.id)
			if (isChecked) return true

			return false
		},
		fillDisciplinasRecorrentes (disciplinaRecorrente) {
			const isChecked = this.filtros.disciplinaId.some(value => value === disciplinaRecorrente.id)
			if (isChecked) return true

			return false
		},
		async obterFiltros (params = this.$route.query) {
			if (params.buscarPor && params.buscarPor !== '') this.filtros.buscarPor = params.buscarPor
			if (params.texto && typeof params.texto === 'string' && params.texto !== '') this.filtros.texto = params.texto
			else this.filtros.texto = ''
			if (params.tipos && typeof params.tipos === 'string' && params.tipos !== '') this.filtros.tipos = params.tipos.split(',')
			else this.filtros.tipos = []
			if (params.curadorias && typeof params.curadorias === 'string' && params.curadorias) this.filtros.curadorias = params.curadorias.split(',')
			else this.filtros.curadorias = []
			if (params.subcuradorias && typeof params.subcuradorias === 'string' && params.subcuradorias) this.filtros.subcuradorias = params.subcuradorias.split(',')
			else this.filtros.subcuradorias = []
			if (params.eixos && typeof params.eixos === 'string' && params.eixos) this.filtros.eixos = params.eixos.split(',')
			else this.filtros.eixos = []
			if (params.cursoId && typeof params.cursoId === 'string' && params.cursoId) this.filtros.cursoId = params.cursoId.split(',')
			else this.filtros.cursoId = []
			if (params.disciplinaId && typeof params.disciplinaId === 'string' && params.disciplinaId) this.filtros.disciplinaId = params.disciplinaId.split(',')
			else this.filtros.disciplinaId = []
			if (params.data && typeof params.data === 'string' && params.data) {
				this.customFormatter(moment(params.data, 'DD/MM/YYYY')._d)
			}	else {
				this.data = ''
				this.filtros.data = ''
			}
		},
		async buscarObjetos (params = Object.assign({}, this.filtros)) {
			this.loadContent = true
			EventBus.$emit('closeLoader', this.loadContent)
			// Envia apenas o último nível de filtro habilitado
			// params.areas = params.eixos.length ? params.eixos : params.subareas.length ? params.subareas : params.areas
			// params.subareas = params.eixos = null

			// Controle de paginação
			params.skip = this.$route.query.skip
			if (params.skip) {
				this.currentPage = parseInt(params.skip)
				params.skip = params.skip > 0 ? parseInt(params.skip) - 1 : params.skip
			} else {
				params.skip = 0
			}

			await objetos.find(params)
				.then(res => {
					this.objetos = res.data
					if (this.objetos.length > 0) this.totalDeObjetos = this.objetos[0].totalDeObjetos
					else this.totalDeObjetos = 0
				})
				.catch(err => console.log(err))

			EventBus.$emit('closeLoader', false)
			this.loadContent = false
		},
		updateFilters (curadoria, nivel) {
			if (nivel === 'curadorias') {
				const subareasID = curadoria.subCuradorias.map(el => el.id)
				this.filtros.subcuradorias = this.filtros.subcuradorias.filter((el, index) => {
					if (subareasID.some(el2 => el === el2)) {
						this.filtros.subcuradorias = this.filtros.subcuradorias.splice(index, 1)
						this.updateFilters(curadoria.subCuradorias.find(el2 => el === el2.id), 'subcuradorias')
						return false
					} else {
						return true
					}
				})
			}

			if (nivel === 'subcuradorias') {
				const eixosID = curadoria.subCuradorias.map(el => el.id)
				this.filtros.eixos = this.filtros.eixos.filter((el, index) => {
					if (eixosID.some(el2 => el === el2)) {
						this.filtros.eixos = this.filtros.eixos.splice(index, 1)
						return false
					} else {
						return true
					}
				})
			}
		},
		updateRoute () {
			const filtros = Object.assign({}, this.filtros)
			Object.keys(filtros).forEach((el) => {
				if (typeof filtros[el] === 'object') {
					filtros[el] = filtros[el].join(',')
				}
			})
			return this.$router.push({
				name: 'resultadoObjeto',
				query: filtros
			})
		},
		resetFilter (type, id) {
			if (type === 'tipos') {
				this.filtros.tipos = this.filtros.tipos.filter(tipo => tipo !== id)
			}
			if (type === 'curadorias') {
				this.filtros.curadorias = this.filtros.curadorias.filter(cur => cur !== id)
			}
			if (type === 'subcuradorias') {
				this.filtros.subcuradorias = this.filtros.subcuradorias.filter(sub => sub !== id)
			}
			if (type === 'eixos') {
				this.filtros.eixos = this.filtros.eixos.filter(e => e !== id)
			}
			if (type === 'texto') {
				this.filtros.texto = ''
			}
			if (type === 'data') {
				this.filtros.data = ''
				this.data = ''
			}
			this.updateRoute()
		},
		resetFilters () {
			let i
			this.data = ''
			for (i in this.filtros) {
				if (this.filtros[i] !== 'object') {
					this.filtros[i] = Array.isArray(this.filtros[i]) ? [] : ''
				}
			}
			this.updateRoute()
			this.buscarObjetos()
		},
		changeFiltrarCuradoria (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const retorno = this.curadoriasBackup.filter(function (el) {
				return condition.test(el.nome.toLowerCase())
			})
			this.curadorias = retorno
		},
		changeFiltrarSubCuradoria (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const result = this.subcuradoriasBackup.filter(function (el) {
				return condition.test(el.nome.toLowerCase())
			})
			this.subcuradorias = result
		},
		changeFiltrarEixo (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const result = this.eixosBackup.filter(function (el) {
				return condition.test(el.nome.toLowerCase())
			})
			this.eixos = result
		},
		changeCursosRecorrente (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const retorno = this.cursosRecorrentesBackup.filter(function (el) {
				return condition.test(el.nome.toLowerCase())
			})
			this.cursosRecorrentes = retorno
		},
		changeDisciplinaRecorrente (e) {
			const condition = new RegExp(e.target.value.toLowerCase())
			const retorno = this.disciplinasRecorrentesBackup.filter(function (el) {
				return condition.test(el.nome.toLowerCase())
			})
			this.disciplinasRecorrentes = retorno
		},
		open () {
			this.$refs.dp1.showCalendar()
		}
	},
	async created () {
		await Promise.all([tipos.find({ status: true }), curadorias.findByTree(), tags.find()])
			.then(res => {
				this.tipos = res[0].data.sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
				this.curadoriasBackup = this.curadorias = res[1].data.sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
				this.disciplinasRecorrentesBackup = this.disciplinasRecorrentes = res[2].data.filter(c => c.identificador === 2).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
				this.cursosRecorrentesBackup = this.cursosRecorrentes = res[2].data.filter(c => c.identificador === 3).sort((el, el2) => el.nome.toUpperCase() > el2.nome.toUpperCase())
			})
			.catch(err => console.log(err))
		await this.obterFiltros()
		await this.buscarObjetos()
	}
}
</script>

<style lang="scss" scoped>
.result-object {
	.page-title {
		color: #59708f;
		text-align: right;
		font-size: 4.2em;
		font-weight: 700;
		font-style: italic;
		text-transform: uppercase;
		margin: 40px 0;
	}

	.search-infos {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #fff;
		margin: 60px 0 0;
		padding: 0 0 6px;
		color: #fff;

		p {
			font-size: 1.2em;

			strong {
				font-weight: 700;
			}
		}
	}

	.search-result {
		display: grid;
		grid-template-columns: 320px auto;
		grid-gap: 0 60px;
		margin: 20px 0 0;
		color: #fff;

		.filters {
			display: flex;
			flex-direction: column;

			.box-data {
				margin-bottom: 20px;
				display: flex;

				.icon-date {
					width: 180px;
					height: 40px;
					border-radius: 5px 0 0 5px;
					background: #0081C8 0% 0% no-repeat padding-box;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}

				.data {
					border-radius: 0 5px 5px 0;
					width: 140px;
					color: #223244;
					// display: flex;
					// align-items: center;
					// justify-content: center;
				}
			}
			// .data {
			// 	.vdp-datepicker {
			// 		background-color: #000;
			// 		.input-class {
			// 			background-color: #000;
			// 		}
			// 	}
			// }

			a {
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 700;
				text-decoration: none;
				margin-bottom: 12px;
				height: 46px;
				color: #fff;
				border-radius: 5px;
				background-color: $dark-blue;
				border: 1px solid #fff;
				transition: .3s ease;

				&:hover {
					background-color: $second-color;
					border: none;
				}

				&.hover, &.active, &.exact-active {
					background-color: $second-color;
					border: none;
				}

				i {
					font-size: 1.7em;
					margin-right: 14px;
				}
			}

			.clean-filters {
				text-align: right;
				margin: 20px 0;

				button {
					background: transparent;
					color: #fff;
					cursor: pointer;
					border: none;
					outline: none;

					i {
						margin-left: 10px;
					}
				}
			}

			.fas.fa-search{
				cursor: pointer;
			}
		}
		.result {
			font-size: 1.7em;
			display: flex;
			justify-content: center;
			margin-top: 40px;
		}
	}
}
</style>

<style>
	.box-data .input-format {
		border-radius: 0 5px 5px 0;
		background-color: #223244;
	}
</style>
